import { render, staticRenderFns } from "./ExportacaoShopControll9.vue?vue&type=template&id=523637fe"
import script from "./ExportacaoShopControll9.vue?vue&type=script&lang=js"
export * from "./ExportacaoShopControll9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports